import { InputBaseComponentProps, TextField, useTheme } from '@mui/material'
import translate from '@src/services/translate'
import { forwardRef } from 'react'
import { FieldError } from 'react-hook-form'
import { SelectValueListItem } from '../data/types/SelectValueListItem'
import translateErrorCode from './TranslateError'

interface Props extends InputBaseComponentProps {
  error?: FieldError
  items: SelectValueListItem[]
  label?: string
}
const SelectComponent = forwardRef<HTMLSelectElement, Props>(function SelectComponent(props, ref) {
  const { error, items, label, ...otherProps } = props as Props
  const theme = useTheme()

  return (
    <TextField
      inputRef={ref}
      label={label}
      error={error !== undefined}
      helperText={translateErrorCode(error)}
      variant="outlined"
      fullWidth
      select
      slotProps={{
        select: {
          native: true,
          inputProps: { ...otherProps },
        },
        inputLabel: { shrink: true },
      }}
    >
      <option aria-label="None" value="" style={{ display: 'none' }} hidden />
      {items.map((item) => (
        <option
          aria-label={item.label ? translate(item.label) : 'Empty'}
          style={{
            color: item.label.toString().includes('**') ? theme.palette.grey[500] : 'none',
          }}
          key={item.value}
          value={item.value}
          disabled={item.disabled}
        >
          {translate(item.label)}
        </option>
      ))}
    </TextField>
  )
})

export default SelectComponent
